module.exports = __webpack_public_path__ + "static/media/predestinado_d.e5700b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/predestinado_d.png
// module id = 1170
// module chunks = 0